/* CustomerOrders.tsx
    Une page affichant la gestion des commandes clients
    Utilise le composant GenericCrudPage pour lister, ajouter, gérer et supprimer les commandes clients
    Utilise l'API correspondante pour les opérations de données
*/

import { faBox } from '@fortawesome/free-solid-svg-icons';
import { CustomerOrdersCrudCard } from 'features/customerOrders/components/CustomerOrdersCrudCard';
import PageHeader from 'layout/PageHeader';

export const CustomerOrders = () => (
	<div className="min-h-screen bg-gray-100 p-6">
		{/* Titre de page */}
		<PageHeader
			icon={faBox}
			title="Commandes clients"
			subtitle="Gérez les commandes que vos clients vous passent"
		/>
		<CustomerOrdersCrudCard size="lg" hideReturn className="mt-6" />
	</div>
);
